/* YUUMA theme behavior: drawers, mega menus, header state, AJAX cart, product form,
   swatches, sticky Add to bag, accordions, galleries and video. No dependencies. */
(function () {
  'use strict';
  var D = document, H = D.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || D).querySelector(sel); };
  var $$ = function (sel, root) { return [].slice.call((root || D).querySelectorAll(sel)); };

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2), parts = v.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1]).replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.hidden = false; clearTimeout(t._t); t._t = setTimeout(function () { t.hidden = true; }, 3200);
  }

  /* ---------- drawers (menu, cart) ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = D.getElementById(id); if (!d) return;
    closeMegas();
    lastFocus = D.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    H.style.overflow = 'hidden';
    $$('[data-open-drawer="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var hdr = $('[data-header]'); if (hdr) hdr.classList.add('is-open');
    setTimeout(function () { var f = $('.drawer__close', d); if (f) f.focus(); }, 60);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) { H.style.overflow = ''; var hdr = $('[data-header]'); if (hdr) hdr.classList.remove('is-open'); }
    $$('[data-open-drawer="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  D.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-drawer]');
    if (o) { if (!D.getElementById(o.getAttribute('data-open-drawer'))) return; e.preventDefault(); openDrawer(o.getAttribute('data-open-drawer')); return; }
    var c = e.target.closest('[data-close-drawer]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('[data-drawer]')); }
  });
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = $('.drawer.is-open'); if (d) { closeDrawer(d); return; }
    closeMegas();
    closeLightbox();
  });
  /* keep focus inside an open drawer */
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var d = $('.drawer.is-open'); if (!d) return;
    var f = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', $('.drawer__panel', d)).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && D.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && D.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- mega menus ---------- */
  var megaTimer = 0;
  function closeMegas() {
    $$('[data-mega]').forEach(function (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); });
    $$('[data-mega-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    var hdr = $('[data-header]'); if (hdr && !$('.drawer.is-open')) hdr.classList.remove('is-open');
  }
  function openMega(id) {
    clearTimeout(megaTimer);
    $$('[data-mega]').forEach(function (m) { var on = m.id === id; m.classList.toggle('is-open', on); m.setAttribute('aria-hidden', on ? 'false' : 'true'); });
    $$('[data-mega-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', t.getAttribute('data-mega-trigger') === id ? 'true' : 'false'); });
    var hdr = $('[data-header]'); if (hdr) hdr.classList.add('is-open');
  }
  function initMega() {
    var bar = $('[data-header-bar]'); if (!bar) return;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    $$('[data-mega-trigger]').forEach(function (t) {
      if (fine) t.addEventListener('mouseenter', function () { openMega(t.getAttribute('data-mega-trigger')); });
      t.addEventListener('focus', function () { openMega(t.getAttribute('data-mega-trigger')); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); openMega(t.getAttribute('data-mega-trigger')); var first = $('#' + t.getAttribute('data-mega-trigger') + ' a'); if (first) first.focus(); }
      });
    });
    $$('[data-mega-close]').forEach(function (a) { a.addEventListener('mouseenter', closeMegas); a.addEventListener('focus', closeMegas); });
    bar.addEventListener('mouseleave', function () { megaTimer = setTimeout(closeMegas, 120); });
    bar.addEventListener('mouseenter', function () { clearTimeout(megaTimer); });
    D.addEventListener('focusin', function (e) { if (!bar.contains(e.target)) closeMegas(); });
  }

  /* ---------- header: solid after scrolling past the top ---------- */
  function initHeader() {
    var hdr = $('[data-header]'); if (!hdr) return;
    var on = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 40); };
    on(); addEventListener('scroll', on, { passive: true });
  }

  /* ---------- AJAX cart ---------- */
  var routes = (window.theme && window.theme.routes) || { cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' };
  function renderCart(sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-body]'), cur = $('[data-cart-body]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    }
    var page = sections['main-cart'];
    if (page && $('[data-main-cart]')) {
      var d2 = new DOMParser().parseFromString(page, 'text/html');
      var f2 = d2.querySelector('[data-main-cart]'); if (f2) $('[data-main-cart]').innerHTML = f2.innerHTML;
    }
  }
  function updateCount(count) { $$('[data-cart-count]').forEach(function (n) { n.textContent = count; }); }
  function sectionIds() { var ids = ['cart-drawer']; if ($('[data-main-cart]')) ids.push('main-cart'); return ids.join(','); }
  function refreshCount() { return fetch(routes.root.replace(/\/$/, '') + '/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); return c; }); }
  function addToCart(body, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    body.sections = sectionIds(); body.sections_url = window.location.pathname;
    return fetch(routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        renderCart(j.sections); refreshCount();
        if (btn) { var lbl = btn.querySelector('[data-label]') || btn; var orig = lbl.textContent; lbl.textContent = btn.getAttribute('data-added') || 'Added ✓'; setTimeout(function () { lbl.textContent = orig; }, 1800); }
        openDrawer('CartDrawer');
        D.dispatchEvent(new CustomEvent('yuuma:cart:added', { detail: j }));
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Couldn’t add to your bag. Please try again.'); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }
  function changeLine(key, qty, el) {
    var body = $('[data-cart-body]'); if (body) body.classList.add('is-loading');
    return fetch(routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty, sections: sectionIds(), sections_url: window.location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { renderCart(j.sections); updateCount(j.item_count); })
      .catch(function (err) { toast((err && err.description) || 'Couldn’t update your bag.'); })
      .finally(function () { var b = $('[data-cart-body]'); if (b) b.classList.remove('is-loading'); });
  }
  D.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (q) { e.preventDefault(); changeLine(q.getAttribute('data-cart-qty'), parseInt(q.getAttribute('data-qty'), 10) || 0, q); return; }
    var a = e.target.closest('[data-add-variant]');
    if (a) { e.preventDefault(); addToCart({ items: [{ id: parseInt(a.getAttribute('data-add-variant'), 10), quantity: 1 }] }, a); }
  });
  D.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-product-form]'); if (!f) return;
    e.preventDefault();
    var fd = new FormData(f), item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }, props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') props[m[1]] = v; });
    if (!props.__shopify_send_gift_card_to_recipient) delete props['Send on'];
    if (Object.keys(props).length) item.properties = props;
    if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
    addToCart({ items: [item] }, e.submitter || $('[type="submit"]', f));
  });

  /* ---------- product: variant swatches for accessories ---------- */
  function initProduct(root) {
    $$('[data-product]', root).forEach(function (p) {
      if (p._init) return; p._init = true;
      var dataEl = $('script[data-variants]', p); if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = $('input[name="id"]', p);
      $$('[data-variant-swatch]', p).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = variants.filter(function (x) { return String(x.id) === b.getAttribute('data-variant-swatch'); })[0]; if (!v) return;
          selectVariant(p, v, idInput);
        });
      });
    });
  }
  function selectVariant(p, v, idInput) {
    if (idInput) idInput.value = v.id;
    $$('[data-variant-swatch]', p).forEach(function (b) { var on = b.getAttribute('data-variant-swatch') === String(v.id); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    $$('[data-color-name]', p).forEach(function (n) { n.textContent = v.option1; });
    $$('[data-sold-tag]', p).forEach(function (n) { n.textContent = v.available ? '' : ' · Sold out'; });
    $$('[data-price]', p).forEach(function (n) { n.textContent = money(v.price); });
    $$('[data-installment]', p).forEach(function (n) { n.textContent = money(Math.round(v.price / 4)); });
    $$('[data-atc]').forEach(function (btn) {
      var lbl = btn.querySelector('[data-label]') || btn;
      btn.disabled = !v.available; lbl.textContent = v.available ? (btn.getAttribute('data-available-label') || 'Add to bag') : 'Sold out';
    });
    $$('[data-sticky-variant]').forEach(function (n) { n.textContent = v.option1 + ' · ' + money(v.price); });
    $$('[data-notify]', p).forEach(function (n) { n.hidden = v.available; });
    if (v.featured_image_index != null) { var g = $('[data-gallery]'); var slide = g && g.querySelectorAll('[data-slide]')[v.featured_image_index]; if (slide) { if (g.scrollWidth > g.clientWidth) g.scrollTo({ left: slide.offsetLeft - g.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); } }
    $$('model-viewer[data-model-prefix]').forEach(function (mv) {
      var pre = mv.getAttribute('data-model-prefix'); if (!pre || !v.option1) return;
      var file = (pre + v.option1).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-') + '.glb';
      var next = mv.getAttribute('src').replace(/[^\/]+\.glb(\?.*)?$/, file);
      if (next !== mv.getAttribute('src')) { mv.closest('.closer').classList.remove('closer--no3d'); mv.setAttribute('src', next); }
    });
    var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
  }

  /* gift card: only ask Shopify to email a recipient when an address is filled in (otherwise it goes to the buyer) */
  D.addEventListener('input', function (e) {
    var em = e.target.closest('[data-gift-email]'); if (!em) return;
    var send = em.form && $('[data-gift-send]', em.form); if (send) send.disabled = !em.value.trim();
  });
  D.addEventListener('change', function (e) { if (e.target.closest('[data-gift-email]')) e.target.dispatchEvent(new Event('input', { bubbles: true })); });

  /* gift card message counter */
  D.addEventListener('input', function (e) {
    var t = e.target.closest('[data-gift-message]'); if (!t) return;
    var c = t.closest('.field') && $('[data-gift-count]', t.closest('.field')); if (c) c.textContent = t.value.length + ' / 200';
  });

  /* gift card amount */
  D.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-gift-amount]'); if (!sel) return;
    var p = sel.closest('[data-product]'); var dataEl = p && $('script[data-variants]', p); if (!dataEl) return;
    var v = JSON.parse(dataEl.textContent).filter(function (x) { return String(x.id) === sel.value; })[0];
    if (v) selectVariant(p, v, $('input[name="id"]', p));
  });

  /* ---------- product: sticky Add to bag on phones and tablets ---------- */
  function initSticky() {
    var atc = $('[data-atc-anchor]'), bar = $('[data-sticky-atc]'); if (!atc || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      var e = es[0]; var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button, a', bar).forEach(function (x) { x.tabIndex = show ? 0 : -1; });
    }).observe(atc);
  }

  /* ---------- accordions ---------- */
  D.addEventListener('click', function (e) {
    var b = e.target.closest('[data-accordion]'); if (!b) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    var group = b.closest('[data-accordion-group]');
    if (group && group.hasAttribute('data-single')) $$('[data-accordion]', group).forEach(function (x) { if (x !== b) x.setAttribute('aria-expanded', 'false'); });
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  /* ---------- gallery: "view all photos" and lightbox ---------- */
  D.addEventListener('click', function (e) {
    var more = e.target.closest('[data-show-all-photos]');
    if (more) { var g = more.closest('[data-gallery]') || $('[data-gallery]'); if (g) g.classList.add('is-expanded'); more.hidden = true; return; }
    var z = e.target.closest('[data-zoom]');
    if (z) { e.preventDefault(); openLightbox(z.getAttribute('data-zoom'), z.getAttribute('aria-label')); return; }
    if (e.target.closest('[data-lightbox-close]')) closeLightbox();
    var st = e.target.closest('[data-lb-step]'); if (st) stepLightbox(parseInt(st.getAttribute('data-lb-step'), 10));
  });
  /* Lightbox — ported from the design: cream full-screen viewer, "n / N", arrows, ← → keys, swipe, click/tap to zoom */
  var lbList = [], lbIndex = 0, lbZoom = false, lbX = null, lbSwiped = false;
  function lbRender() {
    var lb = $('#Lightbox'); if (!lb || !lbList.length) return;
    var img = $('[data-lb-stage] img', lb), cur = lbList[lbIndex];
    img.src = cur.src; img.alt = cur.alt; lbZoom = false; img.style.transform = ''; lb.classList.remove('is-zoomed');
    var c = $('[data-lb-count]', lb); if (c) c.textContent = (lbIndex + 1) + ' / ' + lbList.length;
  }
  function openLightbox(src, label) {
    var lb = $('#Lightbox'); if (!lb) return;
    lbList = $$('[data-gallery] [data-zoom]').map(function (z) { return { src: z.getAttribute('data-zoom'), alt: z.getAttribute('aria-label') || '' }; });
    lbIndex = Math.max(0, lbList.map(function (x) { return x.src; }).indexOf(src)); if (!lbList.length) lbList = [{ src: src, alt: label || '' }];
    lbRender(); lb.hidden = false; H.style.overflow = 'hidden'; var c = $('[data-lightbox-close]', lb); if (c) c.focus();
  }
  function stepLightbox(d) { if (!lbList.length) return; lbIndex = (lbIndex + d + lbList.length) % lbList.length; lbRender(); }
  function closeLightbox() { var lb = $('#Lightbox'); if (!lb || lb.hidden) return; lb.hidden = true; if (!$('.drawer.is-open')) H.style.overflow = ''; }
  D.addEventListener('keydown', function (e) {
    var lb = $('#Lightbox'); if (!lb || lb.hidden) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); stepLightbox(-1); } else if (e.key === 'ArrowRight') { e.preventDefault(); stepLightbox(1); }
  });
  D.addEventListener('pointerdown', function (e) { if (e.target.closest('[data-lb-stage]')) lbX = e.clientX; });
  D.addEventListener('pointerup', function (e) {
    var stg = e.target.closest('[data-lb-stage]'); if (!stg || lbX === null) return;
    var dx = e.clientX - lbX; lbX = null; lbSwiped = Math.abs(dx) > 50 && !lbZoom; if (lbSwiped) stepLightbox(dx < 0 ? 1 : -1);
  });
  D.addEventListener('click', function (e) {
    var stg = e.target.closest('[data-lb-stage]'); if (!stg) return;
    if (lbSwiped) { lbSwiped = false; return; }
    var img = $('img', stg), r = stg.getBoundingClientRect(); lbZoom = !lbZoom;
    img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
    img.style.transform = lbZoom ? 'scale(2.2)' : ''; stg.closest('#Lightbox').classList.toggle('is-zoomed', lbZoom);
  });

  /* ---------- product cards: swatch hover/tap swaps the photo and link ---------- */
  D.addEventListener('click', function (e) {
    var s = e.target.closest('[data-card-swatch]'); if (!s) return;
    e.preventDefault(); pickCardSwatch(s);
  });
  D.addEventListener('mouseover', function (e) { var s = e.target.closest('[data-card-swatch]'); if (s && window.matchMedia('(hover: hover)').matches) pickCardSwatch(s); });
  function pickCardSwatch(s) {
    var card = s.closest('[data-card]'); if (!card) return;
    $$('[data-card-swatch]', card).forEach(function (x) { x.setAttribute('aria-pressed', x === s ? 'true' : 'false'); });
    var img = $('.pcard__img--main', card), href = s.getAttribute('data-href');
    if (img && s.getAttribute('data-img')) { img.src = s.getAttribute('data-img'); img.removeAttribute('srcset'); }
    if (href) $$('[data-card-link]', card).forEach(function (a) { a.href = href; });
    var name = $('[data-card-color]', card); if (name) name.textContent = s.getAttribute('aria-label');
    var price = $('[data-card-price]', card); if (price && s.getAttribute('data-price')) price.textContent = s.getAttribute('data-price');
    var add = $('[data-add-variant]', card); if (add && s.getAttribute('data-variant')) add.setAttribute('data-add-variant', s.getAttribute('data-variant'));
  }

  /* ---------- video: hover-play on cards, pause when off screen, respect reduced motion ---------- */
  function initVideo(root) {
    if (reduceMotion) { $$('video[autoplay]', root).forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); }); }
    $$('[data-hover-video]', root).forEach(function (card) {
      var v = $('video', card); if (!v || card._hv) return; card._hv = true;
      var t = 0;
      var on = function () { if (reduceMotion) return; clearTimeout(t); v.style.opacity = 1; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      var off = function () { v.style.opacity = 0; clearTimeout(t); t = setTimeout(function () { v.pause(); }, 550); };
      card.addEventListener('mouseenter', on); card.addEventListener('mouseleave', off); card.addEventListener('focus', on); card.addEventListener('blur', off);
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (v.hasAttribute('data-hover')) return; if (e.isIntersecting && !reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }); }, { threshold: 0.1 });
      $$('video[data-autoplay-visible]', root).forEach(function (v) { if (!v._io) { v._io = true; io.observe(v); } });
    }
  }

  /* ---------- hero video crossfade ---------- */
  function initHero(root) {
    $$('[data-hero-clips]', root).forEach(function (wrap) {
      var clips = $$('video', wrap); if (clips.length < 2 || reduceMotion || wrap._hc) return; wrap._hc = true;
      /* Only the visible clip plays; the next one starts loading shortly before its turn, and
         everything pauses while the hero is off screen. */
      var i = 0, every = parseInt(wrap.getAttribute('data-interval') || '3200', 10), shown = true, timer = 0;
      var play = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      var warm = function (v) { if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); } };
      var step = function () {
        var prev = clips[i]; i = (i + 1) % clips.length;
        var v = clips[i]; warm(v); try { v.currentTime = 0; } catch (e) {} v.classList.add('is-on'); play(v);
        prev.classList.remove('is-on'); setTimeout(function () { if (clips[i] !== prev) prev.pause(); }, 600);
        setTimeout(function () { warm(clips[(i + 1) % clips.length]); }, Math.max(0, every - 1500));
        timer = setTimeout(step, every);
      };
      clips.forEach(function (v, k) { if (k) v.pause(); });
      setTimeout(function () { warm(clips[1]); }, Math.max(0, every - 1500));
      timer = setTimeout(step, every);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
        var on = es[0].isIntersecting; if (on === shown) return; shown = on;
        if (on) { play(clips[i]); timer = setTimeout(step, every); } else { clearTimeout(timer); clips.forEach(function (v) { v.pause(); }); }
      }).observe(wrap.closest('section') || wrap.parentElement);
    });
  }


  /* ---------- closer look: 3D viewer (model-viewer loads only when the section nears the screen) ---------- */
  var mvLoading = null;
  function loadMV(src) { if (!mvLoading) { mvLoading = new Promise(function (res, rej) { var sc = D.createElement('script'); sc.type = 'module'; sc.src = src; sc.onload = res; sc.onerror = rej; D.head.appendChild(sc); }); } return mvLoading; }
  function initCloser(root) {
    $$('[data-mv-lib]', root).forEach(function (sec) {
      if (sec._cl) return; sec._cl = true;
      var mv = $('model-viewer', sec); if (!mv) return;
      var start = function () { loadMV(sec.getAttribute('data-mv-lib')).catch(function () {}); };
      if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: '300px 0px' }); io.observe(sec); } else start();
      var spots = $$('.hotspot', mv), intro = $('[data-closer-intro]', sec), feat = $('[data-closer-feat]', sec), views = $$('.closer__view', sec), current = null;
      var defaultOrbit = mv.getAttribute('camera-orbit');
      var place = function () {
        try {
          var c = mv.getBoundingBoxCenter(), d = mv.getDimensions();
          spots.forEach(function (b) {
            var f = (b.getAttribute('data-frac') || '0.5 0.5 0.5').trim().split(/\s+/).map(parseFloat);
            var pos = (c.x + (f[0] - 0.5) * d.x).toFixed(4) + 'm ' + (c.y + (f[1] - 0.5) * d.y).toFixed(4) + 'm ' + (c.z + (f[2] - 0.5) * d.z).toFixed(4) + 'm';
            b._pos = pos; mv.updateHotspot({ name: b.slot, position: pos, normal: b.getAttribute('data-normal') || '0 0 1' });
          });
        } catch (_) {}
      };
      mv.addEventListener('load', place);
      mv.addEventListener('error', function () { sec.classList.add('closer--no3d'); });
      var show = function (b) {
        current = b;
        spots.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        if (b) {
          $('[data-closer-ftitle]', sec).textContent = b.getAttribute('data-title');
          $('[data-closer-fdesc]', sec).textContent = b.getAttribute('data-desc');
          feat.hidden = false; requestAnimationFrame(function () { feat.classList.add('is-on'); intro.classList.add('is-off'); });
          if (b._pos) mv.cameraTarget = b._pos;
          if (b.getAttribute('data-orbit')) mv.cameraOrbit = b.getAttribute('data-orbit');
        } else {
          feat.classList.remove('is-on'); intro.classList.remove('is-off');
          mv.cameraTarget = 'auto'; var on = views.filter(function (v) { return v.getAttribute('aria-pressed') === 'true'; })[0];
          mv.cameraOrbit = on ? on.getAttribute('data-orbit') : defaultOrbit;
        }
        mv.fieldOfView = 'auto';
      };
      spots.forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); show(current === b ? null : b); }); });
      views.forEach(function (v) { v.addEventListener('click', function () {
        views.forEach(function (x) { x.setAttribute('aria-pressed', x === v ? 'true' : 'false'); });
        current = null; spots.forEach(function (x) { x.classList.remove('is-on'); }); feat.classList.remove('is-on'); intro.classList.remove('is-off');
        mv.cameraTarget = 'auto'; mv.cameraOrbit = v.getAttribute('data-orbit'); mv.fieldOfView = 'auto';
      }); });
    });
  }

  /* ---------- recently viewed (stored on this device only) ---------- */
  function initRecent() {
    var KEY = 'yuuma-recent', list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) {}
    var cur = $('[data-recent-item]');
    var sec = $('[data-recent]');
    if (sec) {
      var handle = sec.getAttribute('data-current'), lim = parseInt(sec.getAttribute('data-limit') || '6', 10);
      var show = list.filter(function (x) { return x.handle !== handle; }).slice(0, lim);
      if (show.length) {
        var esc = function (t) { var d = D.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
        $('[data-recent-grid]', sec).innerHTML = show.map(function (x) {
          return '<a href="' + esc(x.url) + '" class="recent__item"><img src="' + esc(x.img) + '" alt="' + esc(x.name) + '" loading="lazy"><span class="stack"><span class="recent__name">' + esc(x.name) + '</span><span class="recent__price">' + esc(x.price) + '</span></span></a>';
        }).join('');
        sec.hidden = false;
      }
    }
    if (cur) {
      try {
        var item = JSON.parse(cur.textContent);
        list = [item].concat(list.filter(function (x) { return x.handle !== item.handle; })).slice(0, 12);
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (_) {}
    }
  }

  /* ---------- product extras: back-in-stock ---------- */
  D.addEventListener('click', function (e) {
    var n = e.target.closest('[data-notify-submit]');
    if (n) {
      var box = n.closest('[data-notify]'), inp = $('[data-notify-email]', box), err = $('[data-notify-err]', box), em = (inp.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { err.hidden = false; inp.focus(); return; }
      err.hidden = true; n.disabled = true;
      var color = ($('[data-color-name]') || {}).textContent || '';
      var body = new URLSearchParams();
      body.append('form_type', 'contact'); body.append('utf8', '✓');
      body.append('contact[email]', em);
      body.append('contact[body]', 'Back-in-stock request: ' + $('[data-notify-form]', box).getAttribute('data-product-title') + (color ? ' (' + color + ')' : '') + '\n' + location.href);
      body.append('contact[tags]', 'back-in-stock');
      fetch((window.theme && window.theme.routes && window.theme.routes.root || '/').replace(/\/?$/, '/') + 'contact', { method: 'POST', body: body, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        .catch(function () {}).then(function () {
          var esc = D.createElement('span'); esc.textContent = em;
          box.innerHTML = '<span class="pdp__notify-title">You\'re on the list</span><span style="font-size:13px;color:var(--body2)">We\'ll email ' + esc.innerHTML + ' the moment ' + (color ? D.createTextNode(color).textContent.replace(/</g, '&lt;') : 'she') + ' is back.</span>';
        });
    }
  });

  /* ---------- header image parallax (collection and page headers) ---------- */
  function initParallax() {
    var media = $('[data-hero-media]'), copy = $('[data-hero-copy]'); if (!media || reduceMotion) return;
    var raf = 0;
    var run = function () {
      raf = 0; var y = window.scrollY, vh = window.innerHeight; if (y > vh * 1.2) return;
      media.style.transform = 'translate3d(0,' + (y * 0.4).toFixed(1) + 'px,0) scale(1.06)';
      if (copy) { copy.style.transform = 'translate3d(0,' + (y * 0.18).toFixed(1) + 'px,0)'; copy.style.opacity = Math.max(0, 1 - y / (vh * 0.75)).toFixed(3); }
    };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(run); }, { passive: true }); run();
  }

  /* ---------- image parallax (ported from the design's SiteHeader initParallax) ----------
     Large cover photos drift slightly with the scroll. Product cards, galleries, heroes and
     pages with their own motion are left alone (the design marks those data-no-parallax). */
  var PX_SKIP = 'header, footer, aside, [data-no-parallax], .pcard, .pdp__gallery, .recent, #Lightbox, .cstrip, .hero, [data-hero-media], [data-hero-clips], [data-xhero], [data-brand-px], [data-chapters], .drawer, .wel, .mega, model-viewer, .closer__stage';
  function initImageParallax() {
    if (reduceMotion || window.__yuumaPx) return; window.__yuumaPx = true;
    var mode = new WeakMap();
    var classify = function (img) {
      if (img.closest(PX_SKIP)) return 'skip';
      var r = img.getBoundingClientRect(); if (r.width < 160 || r.height < 120) return 'skip';
      var p = img.parentElement, pr = p.getBoundingClientRect(), cs = getComputedStyle(img);
      var op = cs.objectPosition.split(' '); img.dataset.ox = op[0] || '50%'; img.dataset.oy = String(parseFloat(op[1]) || 50);
      if (cs.objectFit === 'contain') return 'skip';
      if (cs.position === 'absolute' || (Math.abs(pr.width - r.width) < 3 && Math.abs(pr.height - r.height) < 3)) { p.style.overflow = 'hidden'; return 'transform'; }
      return cs.objectFit === 'cover' ? 'pos' : 'skip';
    };
    /* Only on-screen images are moved, and only on frames where the page actually scrolled. */
    var near = new Set(), pos = new WeakMap(), raf = 0, sy = window.scrollY;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      var y = window.scrollY;
      es.forEach(function (e) {
        if (e.isIntersecting) { near.add(e.target); pos.set(e.target, [e.boundingClientRect.top + y, e.boundingClientRect.height]); }
        else near.delete(e.target);
      }); req();
    }, { rootMargin: '100px 0px' }) : null;
    /* positions are measured once (above) and re-measured only when the page's height changes */
    var remeasure = function () { var y = window.scrollY; near.forEach(function (img) { var r = img.getBoundingClientRect(); pos.set(img, [r.top + y, r.height]); }); req(); };
    if ('ResizeObserver' in window) new ResizeObserver(function () { remeasure(); }).observe(D.body);
    var watched = new WeakSet();
    var collect = function () {
      D.querySelectorAll('img').forEach(function (img) {
        if (watched.has(img) || !img.complete || !img.naturalWidth || img.hasAttribute('data-no-parallax')) return;
        watched.add(img); if (io) io.observe(img); else near.add(img);
      });
    };
    var vh = window.innerHeight;
    var tick = function () {
      raf = 0; if (H.classList.contains('yu-motion')) return;
      var todo = [], y = sy;
      near.forEach(function (img) {
        if (!img.isConnected || img.hasAttribute('data-no-parallax')) { near.delete(img); return; }
        var m = mode.get(img); if (!m) { m = classify(img); mode.set(img, m); }
        if (m === 'skip') { near.delete(img); if (io) io.unobserve(img); return; }
        var q = pos.get(img); if (!q) { var b = img.getBoundingClientRect(); q = [b.top + y, b.height]; pos.set(img, q); }
        var top = q[0] - y, h = q[1];
        todo.push([img, m, Math.max(-1, Math.min(1, ((top + h / 2) - vh / 2) / (vh / 2 + h / 2)))]);
      });
      todo.forEach(function (d) {
        var img = d[0], t = d[2];
        if (d[1] === 'transform') { img.style.transform = 'translate3d(0,' + (t * 5).toFixed(2) + '%,0) scale(1.12)'; img.style.willChange = 'transform'; }
        else img.style.objectPosition = img.dataset.ox + ' ' + Math.max(0, Math.min(100, +img.dataset.oy + t * 14)).toFixed(1) + '%';
      });
    };
    var req = function () { if (!raf) raf = requestAnimationFrame(tick); };
    collect();
    D.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') { collect(); req(); } }, true);
    window.addEventListener('load', function () { collect(); req(); });
    /* the scroll position is read in the scroll event, before anything on the page moves this frame */
    window.addEventListener('scroll', function () { sy = window.scrollY; req(); }, { passive: true });
    window.addEventListener('resize', function () { vh = window.innerHeight; sy = window.scrollY; remeasure(); });
    req();
  }

  /* ---------- first-section hero drift + fade on content pages (ported from the design's SiteHeader initHero) ----------
     Home, product, collection and Our Story pages have their own hero motion. */
  function initPageHero() {
    var B = D.body;
    if (reduceMotion || window.__yuumaHero || /template-(index|product|collection|password|gift_card)\b/.test(B.className) || /template-page--our-story\b/.test(B.className)) return;
    window.__yuumaHero = true;
    var off = function () { return H.classList.contains('yu-motion'); };
    var hero = null, media = [], body = [], raf = 0;
    var find = function () {
      hero = $$('main section').filter(function (s) { return !s.closest('header, footer, aside, [data-xhero], [data-chapters]') && s.getBoundingClientRect().top < window.innerHeight * 0.6; })[0];
      if (!hero) return false;
      media = $$(':scope > img, :scope > video, :scope > div > img, :scope > picture img', hero).filter(function (m) { return m.getBoundingClientRect().width > window.innerWidth * 0.3; });
      media.forEach(function (m) { m.setAttribute('data-no-parallax', ''); m.style.willChange = 'transform'; if (m.parentElement) m.parentElement.style.overflow = 'hidden'; });
      body = [].slice.call(hero.children).filter(function (c) { return media.indexOf(c) < 0 && !c.querySelector('img, video') && c.getAttribute('aria-hidden') !== 'true'; });
      body.forEach(function (b) { b.style.willChange = 'transform, opacity'; });
      return true;
    };
    var run = function () {
      raf = 0; if (!hero && !find()) return;
      if (off()) { media.forEach(function (m) { m.style.transform = ''; }); body.forEach(function (b) { b.style.transform = ''; b.style.opacity = ''; }); return; }
      var h = hero.offsetHeight || 1, y = Math.max(0, Math.min(h, -hero.getBoundingClientRect().top)), k = y / h;
      media.forEach(function (m) { m.style.transform = 'translate3d(0,' + (y * 0.35).toFixed(1) + 'px,0) scale(' + (1.06 + k * 0.04).toFixed(4) + ')'; });
      body.forEach(function (b) { b.style.transform = 'translate3d(0,' + (y * 0.18).toFixed(1) + 'px,0)'; b.style.opacity = Math.max(0, 1 - k * 1.3).toFixed(3); });
    };
    var req = function () { if (!raf) raf = requestAnimationFrame(run); };
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', function () { hero = null; req(); });
    setTimeout(req, 300); setTimeout(function () { hero = null; req(); }, 1500);
  }

  /* Footer link groups: collapsed accordions on phones (design), always open on larger screens */
  function initFooterCols() {
    var mq = window.matchMedia('(max-width: 719px)');
    var set = function () { $$('[data-footer-col]').forEach(function (d) { d.open = !mq.matches; }); };
    set(); if (mq.addEventListener) mq.addEventListener('change', set);
    D.addEventListener('click', function (e) { var s = e.target.closest('[data-footer-col] > summary'); if (s && !mq.matches) e.preventDefault(); });
  }

  /* Reveal on scroll — the design's Home reveal(): rise 48px, 6px blur clears, 900ms; siblings follow 90ms apart */
  var revealIO = null;
  function initReveal(root) {
    if (reduceMotion || !('IntersectionObserver' in window) || H.classList.contains('yu-motion') || (window.Shopify && Shopify.designMode)) return;
    if (!revealIO) revealIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var t = e.target; t.style.opacity = '1'; t.style.transform = 'none'; t.style.filter = 'none'; revealIO.unobserve(t); } }); }, { rootMargin: '0px 0px -12% 0px' });
    var ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
    $$('[data-reveal]', root).forEach(function (el) {
      if (el._rv) return; el._rv = true;
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      var sibs = [].slice.call(el.parentElement.children).filter(function (c) { return c.hasAttribute('data-reveal'); }), d = Math.max(0, sibs.indexOf(el)) * 90;
      el.style.opacity = '0'; el.style.transform = 'translateY(48px)'; el.style.filter = 'blur(6px)';
      el.style.transition = ['opacity', 'transform', 'filter'].map(function (pr) { return pr + ' 900ms ' + ease + ' ' + d + 'ms'; }).join(', ');
      revealIO.observe(el);
    });
  }

  /* ---------- customer videos: play while on screen, tap for sound ---------- */
  var MUTED = '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5h3l4-3.5v12l-4-3.5H3z"/><path d="M13.5 7.5l4 5M17.5 7.5l-4 5"/></svg>';
  var SOUND = '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5h3l4-3.5v12l-4-3.5H3z"/><path d="M13.5 7a4 4 0 0 1 0 6M15.5 5a7 7 0 0 1 0 10"/></svg>';
  var ugcIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting && !reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }); }, { threshold: 0.6 }) : null;
  function initUgc(root) { if (ugcIO) $$('video[data-ugc-video], .pdp__irl-tile video', root).forEach(function (v) { if (!v._ugc) { v._ugc = true; ugcIO.observe(v); } }); }
  function ugcSound(v) {
    v.muted = !v.muted;
    if (!v.muted) { $$('video[data-ugc-video]').forEach(function (o) { if (o !== v) o.muted = true; }); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    $$('[data-ugc-tile]').forEach(function (o) { var i = $('[data-ugc-sound]', o), ov = $('video', o); if (i && ov) i.innerHTML = ov.muted ? MUTED : SOUND; });
  }
  D.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ugc-tile]');
    if (t) { var v = $('video', t); if (v) ugcSound(v); return; }
    /* "See it IRL" thumbnails: jump to the customer videos section and play the matching video with sound */
    var irl = e.target.closest && e.target.closest('[data-irl-index]');
    if (irl) {
      var sec = $('#ugc'); if (!sec) return; e.preventDefault(); e.stopPropagation();
      var lenis = window.__yuumaLenis, y = Math.max(0, sec.getBoundingClientRect().top + window.scrollY - 90); if (lenis && lenis.scrollTo) lenis.scrollTo(y); else window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' });
      var tiles = $$('[data-ugc-tile]', sec), tile = tiles[parseInt(irl.getAttribute('data-irl-index'), 10)] || tiles[0];
      if (tile) { var tv = $('video', tile); if (tv && tv.muted) ugcSound(tv); tile.focus({ preventScroll: true }); var row = tile.parentElement; if (row && row.scrollTo) row.scrollTo({ left: tile.offsetLeft - row.offsetLeft, behavior: 'smooth' }); }
      return;
    }
    /* drop a hint: native share sheet, falling back to an email */
    var h = e.target.closest && e.target.closest('[data-drop-hint]');
    if (h) {
      var url = location.origin + location.pathname, text = h.getAttribute('data-hint-text');
      if (navigator.share) { navigator.share({ title: h.getAttribute('data-hint-title'), text: text, url: url }).catch(function () {}); return; }
      location.href = 'mailto:?subject=' + encodeURIComponent('A little hint') + '&body=' + encodeURIComponent(text + '\n\n' + url);
    }
  });

  /* ---------- shipping details: estimated delivery window (business days) ---------- */
  function initDelivery(root) {
    $$('[data-delivery-estimate]', root).forEach(function (el) {
      try {
        var add = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
        var f = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
        var lo = parseInt(el.getAttribute('data-min') || '3', 10), hi = parseInt(el.getAttribute('data-max') || '7', 10), now = new Date();
        el.textContent = '· Arrives ' + f(add(now, lo)) + ' – ' + f(add(now, Math.max(lo, hi)));
      } catch (_) {}
    });
  }

  function init(root) { initProduct(root); initVideo(root); initHero(root); initCloser(root); initReveal(root); initUgc(root); initDelivery(root); }
  D.addEventListener('DOMContentLoaded', function () { initMega(); initHeader(); initSticky(); init(D); initRecent(); initParallax(); initImageParallax(); initPageHero(); initFooterCols(); });
  D.addEventListener('shopify:section:load', function (e) { init(e.target); initSticky(); });
  /* A cart app may replace the theme drawer: drop references to elements that no longer exist */
  function tidyAria() { $$('[aria-controls]').forEach(function (el) { if (!D.getElementById(el.getAttribute('aria-controls'))) el.removeAttribute('aria-controls'); }); }
  window.addEventListener('load', function () { setTimeout(tidyAria, 2500); });
  window.YUUMA = { addToCart: addToCart, openDrawer: openDrawer, money: money };
})();
